import NoData from "assets/svgs/no_data/NoData";
import { isEmpty } from "lodash";
import PaginationDiv from "modules/pagination/PaginationDiv";
import { fourPlaceHolder, getValue } from "modules/utilities/utility";
import React, { useEffect, useMemo, useState } from "react";
import { Form} from "react-bootstrap";
import { useToast } from "modules/navbar/top/store/toasterStore";
import CardDiv from "modules/common/card-div/CardDiv";
import { useComponentStore } from "modules/manage_components/store";
import { Input, Select } from "antd";
import ComponentEditModal from "modules/manage_components/ComponentEditModal";
import ModalCompView from "modules/manage_components/ModalCompView";

function ManageComponents() {
  const {
    componentData,
    componentLoading,
    fetchComponentData,
    updateActiveStatus,
    fetchActiveFilterData
  } = useComponentStore();
  const [page, newPage] = useState(1);
  const { setToaster } = useToast();
  const { Search } = Input;
  const [searchText, setSearchText] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [componentId, setComponentId] = useState("");
  const [modalViewShow, setModalViewShow] = useState(false);
  const [viewId, setViewId] = useState("");
  const [type, setType] = useState("");
  const [filter, setActiveFilter]=useState();

  //commented due to changes in implementation of active filter api

  // useEffect(() => {
  //   if (searchText) {
  //     const debounceTimeout = setTimeout(() => {
  //       const keyword = `keyword=${searchText}&`;
  //       fetchComponentData(page - 1, keyword);
  //     }, 700);
  //     return () => {
  //       clearTimeout(debounceTimeout);
  //     };
  //   } else {
  //     fetchComponentData(page - 1, "");
  //   }
  // }, [page, searchText, activeFilter]);

  useEffect(() => {
    if (searchText) {
      const debounceTimeout = setTimeout(() => {
        const keyword = `keyword=${searchText}&`;
        if (searchText && filter) {
          fetchComponentData(page - 1, keyword, `isActive=${filter=="active"?true:false}&`);
        } else {
          fetchComponentData(page - 1, keyword ,"");
        }
      }, 700);
      return () => {
        clearTimeout(debounceTimeout);
      };
    }
    if (filter) {
      fetchComponentData(page - 1,"", `isActive=${filter=="active"?true:false}&`);
    } else {
      fetchComponentData(page - 1, "", "");
    }
  }, [page, filter, searchText]);


  const compData = useMemo(() => {
    if (isEmpty(componentData?.data)) return [];
    const _data = componentData?.data.results.map((row) => ({
      key: getValue(row, "id"),
      componentName: getValue(row, "display_name"),
      order: getValue(row, "order"),
      switch: getValue(row, "is_active"),
      displayTitle: getValue(row, "display_title"),
    }));
    _data.sort((responseOne, responseTwo) => responseOne.componentName.localeCompare(responseTwo.componentName));
    return _data;
  }, [componentData?.data]);

  const handleCheckBox = (event, id, active) => {
    const check = event.target.checked ? true : false;
    updateActiveStatus(id, check, setToaster, fetchComponentData, searchText);
  };

  const handleSearch = (value) => {
    setSearchText(value);
  };

  const handleEditClick = (id) => {
    setComponentId(id);
    setModalShow(true);
  };

  const handleView = (id, viewType) => {
    setViewId(id);
    setType(viewType);
    setModalViewShow(true);
  };
  const header = [
    "Display Name",
    "Added Segment",
    "Added Content",
    "Active Status",
    "Action",
  ];

  const activeOption=[
    {value:"active", label:"True"},
    {value:"inactive", label:"False"},
  ]

  return (
    <div>
      <CardDiv
        title={
          <div className="d-flex justify-content-between">
            <div className="fs-2">Manage Components</div>
            <div className="d-flex gap-3">
              <Select
                allowClear
                placeholder="Active Filter"
                value={filter}
                style={{ width: 130 }}
                onChange={(role) => {
                  setActiveFilter(role);
                }}
                options={activeOption}
              />
              <Search
                allowClear
                placeholder="Search"
                onSearch={handleSearch}
                onChange={({ target }) => handleSearch(target.value)}
                maxLength={80}
              />
            </div>
          </div>
        }
        component={
          <>
            <div>
              <div
                className="mt-1 shadow rounded mt-3 scrollable-container"
                style={{ maxHeight: "70vh", overflowY: "scroll" }}
              >
                <div
                  className="d-flex table-head rounded-top"
                  style={{ position: "sticky", top: "0" }}
                >
                  {header?.map((item) => {
                    return (
                      <span className="p-3 py-4 fw-bold text-black flex-1 border-end">
                        {item}
                      </span>
                    );
                  })}
                </div>
                {componentLoading ? (
                  fourPlaceHolder()
                ) : compData && compData?.length ? (
                  compData?.map((item, index) => {
                    return (
                      <div
                        className={`d-flex table-row border-1 border-top-0 ${
                          index === compData?.length - 1 && `rounded-bottom`
                        }`}
                      >
                        <span className="p-3  flex-1 text-break text-black text-wrap border-end">
                          <div className="d-flex flex-column">
                            <span className="fw-bold">
                              {item?.displayTitle}
                            </span>
                            <span className="text-primary">
                              slug: {item?.componentName}
                            </span>
                          </div>
                        </span>
                        <span
                          className="p-3 flex-1 text-break  text-wrap border-end cursor-pointer fw-bold text-primary"
                          onClick={() => handleView(item?.key, "segments")}
                        >
                          View All
                        </span>
                        <span
                          className="p-3 flex-1 text-break text-wrap border-end fw-bold cursor-pointer text-primary"
                          onClick={() => handleView(item?.key, "contents")}
                        >
                          View All
                        </span>
                        <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                          <Form.Check
                            type="checkbox"
                            id="checkedCheckbox"
                            label={item?.switch ? "Active" : "Inactive"}
                            onClick={(event) =>
                              handleCheckBox(event, item?.key, item?.switch)
                            }
                            defaultChecked={item?.switch ? true : false}
                          />
                        </span>
                        <span className="p-3 d-flex gap-4 flex-1 text-break text-black text-wrap border-end">
                          <span
                            onClick={() => handleEditClick(item?.key)}
                            className="cursor-pointer text-primary fw-bold"
                          >
                            Edit
                          </span>
                        </span>
                      </div>
                    );
                  })
                ) : (
                  <div className="p-3 bg-white rounded-bottom text-center">
                    No Data Available <NoData />
                  </div>
                )}
              </div>
            </div>
            <div>
              <PaginationDiv
                paginationData={{
                  pageCount: componentData?.data?.total
                    ? Math.ceil(componentData?.data?.total / 10)
                    : 1,
                  page: page,
                }}
                newPage={newPage}
              />
            </div>
          </>
        }
      />
      <ComponentEditModal
        modalShow={modalShow}
        setModalShow={setModalShow}
        componentId={componentId}
        searchText={searchText}
      />
      <ModalCompView
        modalShow={modalViewShow}
        setModalShow={setModalViewShow}
        contentKey={viewId}
        type={type}
      />
    </div>
  );
}

export default ManageComponents;
